import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSocket } from "./SocketContext";
import {
  SOCKET_EVENT_TYPE,
  TYPE,
  USER_CURRENT_PATH,
} from "../../helpers/common";
import { useDispatch, useSelector } from "react-redux";
import {
  updateSessionData,
  updateIsCloseSession,
  updateLastQuestionAsked,
  resetSessionState,
  isNavOpen,
  updateLastSummaryRating,
} from "../../redux/slices/sessionSlice";
import { resetFeelingState } from "../../redux/slices/feelingSlice";
import { getUserById } from "../../redux/actions/sessionAction";

const useSocketHandlers = () => {
  const store = useSelector((store) => store);
  const sessionData = store.session?.sessionData || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { socket, setUserId } = useSocket();

  //Create Session first User listener
  const handleCreateSession = ({ data }) => {
    try {
      if (!data || !data.userId || !data.session_id) return;
      const { userId, session_id } = data;
      setUserId(userId);
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      if (!loggedUser) return;
      if (loggedUser.session_id !== session_id || loggedUser.id !== userId)
        return;
      navigate(
        `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.GENERATE_LINK}`,
      );
    } catch (error) {
      console.error("Error in handleCreateSession:", error);
    }
  };
  //Create Session other User listener
  const handleRoomJoined = ({ message, data }) => {
    try {
      if (
        !data ||
        !data?.isJoined ||
        !data.sender ||
        !data.receiver ||
        !data.session_id
      )
        return;
      const { receiver, sender, session_id } = data;
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      if (!loggedUser) return;
      if (loggedUser.session_id !== session_id || loggedUser.id !== sender.id)
        return;
      navigate(
        `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.CONTINUE}`,
      );
      dispatch(updateSessionData({ ...sessionData, receiver }));
    } catch (error) {
      console.error("Error in handleRoomJoined:", error);
    }
  };
  //handle join by other user listener for first user
  const handleJoinRoom = (data) => {
    const {
      data: { sender, receiver, session_id },
      message,
    } = data;
    const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
    if (!loggedUser || !sender || !receiver || !session_id) return;
    if (
      loggedUser?.session_id !== session_id ||
      loggedUser?.id !== receiver?.id
    )
      return;
    navigate(
      `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.USER_WAITING}`,
    );
    dispatch(updateSessionData({ ...sessionData, receiver: sender }));
  };

  const handleFinishedQuestionAsked = ({ message, data }) => {
    if (!data) return;
    const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
    if (!loggedUser) return;
    const { sessionId, sender, receiver } = data;
    if (sessionId !== loggedUser.session_id || receiver.id !== loggedUser.id)
      return;
    navigate(
      `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.SUMMARIZED_QUESTION_ASK}`,
    );
  };

  const handlestatementMadeFinished = ({ message, data }) => {
    const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
    if (!loggedUser) return;
    const { sessionId, receiver } = data;
    if (sessionId === loggedUser.session_id && loggedUser.id === receiver?.id) {
      // toast.success(message);
      navigate(
        `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.SUMMARIZED_WHAT_SAID}`,
      );
    }
  };

  const handleSummarizeQuestionFinish = ({ message, data }) => {
    const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
    if (!loggedUser) return;
    const { sessionId, receiver } = data;
    if (sessionId === loggedUser.session_id && loggedUser.id === receiver?.id) {
      // toast.success(message);
      navigate(
        `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.SUMMARIZED_QUESTION_FINISH}`,
      );
    }
  };
  // done above
  const handleFinishSummarizeQuestion = ({ message, data }) => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      if (!loggedUser || !data) {
        console.error("Error: Invalid user or data");
        return;
      }
      const { sessionId, sender } = data;
      if (
        sessionId !== loggedUser?.session_id ||
        !sender ||
        loggedUser?.id !== sender?.id
      ) {
        return;
      }
      navigate(
        `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.WAIT_TO_CONTINUE}`,
      );
    } catch (error) {
      console.error("Error handling summarize question:", error);
    }
  };
  //handle summarizing submit response of questions sender
  const handleSubmitSummariseResponse = ({ message, data }) => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      dispatch(getUserById(loggedUser));
      if (!data.sender || !data.receiver || !loggedUser) return;
      const { sessionId, isSummarizedGood } = data;
      if (sessionId !== loggedUser?.session_id) return;
      if (isSummarizedGood) {
        navigate(
          `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.LISTEN_ANSWER}`,
        );
      } else {
        navigate(
          `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.USER_ASK}`,
        );
      }
    } catch (error) {}
  };
  //handle summarizing submit response of questions receiver
  const handleSummarizeQuestionResponse = ({ message = "", data = null }) => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      dispatch(getUserById(loggedUser));
      if (!data || !data.sessionId || !data.receiver || !loggedUser) return;
      const { sessionId, receiver, isSummarizedGood, result } = data;
      if (
        sessionId !== loggedUser?.session_id ||
        loggedUser?.id !== receiver?.id
      )
        return;
      console.log("answer OF QUESTION SUMMARIZED", result);
      dispatch(updateLastSummaryRating(result));
      setTimeout(() => {
        if (isSummarizedGood) {
          navigate(
            `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.ANSWER_QUESTION}`,
          );
        } else {
          navigate(
            `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.LISTEN}`,
          );
        }
        dispatch(updateLastSummaryRating(null));
      }, 4000);
    } catch (error) {
      console.error("Error in handleSummarizeQuestionResponse:", error);
    }
  };

  //handle statement finish by the sender
  const handleAnswerFinishBySender = ({ message, data }) => {
    const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
    if (!data.sender || !data.receiver || !loggedUser) return;
    const { sessionId, sender } = data;
    if (sessionId !== loggedUser?.session_id) return;
    if (loggedUser?.id !== sender?.id) return;
    navigate(
      `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.CONTINUE_AFTER_FINISH_ASNWER}`,
    );
  };

  //handle statement finish by the sender
  const handleStatementmentFinishBySender = ({ message, data }) => {
    const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
    if (!data.sender || !data.receiver || !loggedUser) return;
    const { sessionId, sender } = data;
    if (sessionId !== loggedUser?.session_id) return;
    if (loggedUser?.id !== sender?.id) return;
    navigate(
      `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.CONTINUE_AFTER_FINISH}`,
    );
  };
  //handle statement finish by the receiver
  const handleStatementmentFinishByReceiver = ({ message, data }) => {
    const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
    if (!data.sender || !data.receiver || !loggedUser) return;
    const { sessionId, receiver, sender } = data;
    if (sessionId !== loggedUser?.session_id) return;
    if (loggedUser?.id !== receiver?.id) return;
    // toast.success(message);
    if (window.location.pathname == USER_CURRENT_PATH.ANSWER_SUMMARIZE_LISTEN) {
      localStorage.setItem("isAnswer", true);
    } else {
      localStorage.setItem("isAnswer", false);
    }
    navigate(
      `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.SUMMARIZED}`,
    );
  };

  //handle answer finish by the receiver
  const handleAnswerFinishByReceiver = ({ message, data }) => {
    const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
    if (!data.sender || !data.receiver || !loggedUser) return;
    const { sessionId, receiver, sender } = data;
    if (sessionId !== loggedUser?.session_id) return;
    if (loggedUser?.id !== receiver?.id) return;
    // toast.success(message);
    if (window.location.pathname == USER_CURRENT_PATH.ANSWER_SUMMARIZE_LISTEN) {
      localStorage.setItem("isAnswer", true);
    } else {
      localStorage.setItem("isAnswer", false);
    }
    navigate(
      `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.SUMMARIZED_ANSWER}`,
    );
  };

  const handleFinishMakingStatement = (data) => {
    if (!data) return;
    const {
      message,
      data: { receiver, sender, sessionId },
    } = data;
    const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
    if (loggedUser.session_id === sessionId) {
      if (loggedUser.id === sender.id) {
        // toast.success(message)
        navigate(
          `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.SUMMARIZED_SAID}`,
        );
      }
    }
  };

  const handleFinishAskingQuestion = ({ data, message }) => {
    if (!data) return;
    const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
    if (loggedUser?.session_id !== data?.sessionId) return;
    const { sender } = data;
    if (sender?.id !== loggedUser?.id) return;
    // toast.success(message);
    setTimeout(() => {
      navigate(
        `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.SUMMARIZED_ASK}`,
      );
    }, 500);
  };

  const handleQuestionAsked = (data) => {
    try {
      if (!data || !data?.data) return;
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      if (!loggedUser || !data) return;
      const { sessionId, type, sender, receiver, questionId, isEmotionView } =
        data?.data || {};
      if (sessionId !== loggedUser?.session_id || type !== TYPE.ASKING_QUESTION)
        return;
      if (loggedUser.id === sender?.id) {
        if (isEmotionView) {
          localStorage.setItem("firstStage", "true");
          navigate(
            `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.EMOTIONS}`,
          );
          dispatch(updateLastQuestionAsked(sender));
          //02-04-2025
          localStorage.setItem("lastStage", "first");
        } else {
          navigate(
            `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.USER_ASK}`,
          );
        }
      } else if (loggedUser.id === receiver?.id) {
        if (isEmotionView) {
          localStorage.setItem("firstStage", "true");
          navigate(
            `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.EMOTIONS}`,
          );
          dispatch(updateLastQuestionAsked(sender));
          //02-04-2025
          localStorage.setItem("lastStage", "first");
        } else {
          navigate(
            `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.LISTEN}`,
          );
        }
      }
      if (loggedUser?.id === sender?.id || loggedUser?.id === receiver?.id) {
        localStorage.setItem(
          "currentUser",
          JSON.stringify({ ...loggedUser, questionId }),
        );
      }
    } catch (error) {}
  };

  const handleQuestionMake = ({ data, message }) => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      if (
        !data ||
        !data?.sender ||
        !data?.receiver ||
        !data?.sessionId ||
        !loggedUser
      )
        return;
      const { sessionId, type, sender, receiver, statementId, isEmotionView } =
        data;
      if (sessionId !== loggedUser?.session_id || type !== TYPE.STATEMENT_MAKE)
        return;
      if (loggedUser.id === sender?.id) {
        if (isEmotionView) {
          localStorage.setItem("firstStage", "true");
          navigate(
            `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.EMOTIONS}`,
          );
          dispatch(updateLastQuestionAsked(sender));
          localStorage.setItem("lastStage", "first");
        } else {
          navigate(
            `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.TELL_USER}`,
          );
        }
      } else if (loggedUser?.id === receiver?.id) {
        if (isEmotionView) {
          localStorage.setItem("firstStage", "true");
          navigate(
            `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.EMOTIONS}`,
          );
          dispatch(updateLastQuestionAsked(sender));
          //02-04-2025
          localStorage.setItem("lastStage", "first");
        } else {
          navigate(
            `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.SAY_SOMETHING}`,
          );
        }
      }
      if (loggedUser?.id === sender?.id || loggedUser?.id === receiver?.id) {
        localStorage.setItem(
          "currentUser",
          JSON.stringify({ ...loggedUser, statementId }),
        );
      }
    } catch (error) {}
  };
  //handle response if a statement finish for the sender
  const handleFinishStatementResForSender = ({ message = "", data = null }) => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      if (!data.sender || !data.sessionId || !data.receiver || !loggedUser)
        return;
      const { sessionId, sender } = data;
      if (sessionId !== loggedUser?.session_id || loggedUser?.id !== sender?.id)
        return;
      setTimeout(() => {
        navigate(
          `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.USER_WAITING}`,
        );
      }, 500);
    } catch (error) {
      console.error("Error in handleSummarizeQuestionResponse:", error);
    }
  };
  //handle statement submit summarizing for sender,who submit
  // const handleSubmitStatementResForSender = ({ message = "", data = null }) => {
  //     try {
  //         const loggedUser = JSON.parse(localStorage.getItem('currentUser'));
  //         dispatch(getUserById(loggedUser));
  //         if (!data.sender || !data.sessionId || !data.receiver || !loggedUser) return
  //         const { sessionId, isSummarizedGood } = data;
  //         if (sessionId !== loggedUser?.session_id) return;
  //         if (isSummarizedGood) {
  //             navigate(`${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.CONTINUE_AFTER_FINISH}`);
  //         } else {
  //             navigate(`${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.TELL_USER}`);
  //         }
  //     } catch (error) {
  //         console.error("Error in handleSummarizeQuestionResponse:", error);
  //     }
  // };
  // const handleSubmitStatementResForReceiver = ({ message = "", data = null }) => {
  //     try {
  //         const loggedUser = JSON.parse(localStorage.getItem('currentUser'));
  //         if (!data.sender || !data.sessionId || !data.receiver || !loggedUser) return
  //         const { sessionId, receiver, isSummarizedGood } = data;
  //         if ((sessionId !== loggedUser?.session_id) || (loggedUser?.id !== receiver?.id)) return
  //         if (isSummarizedGood) {
  //             navigate(`${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.USER_WAITING}`);
  //         } else {
  //             navigate(`${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.SAY_SOMETHING}`);
  //         }
  //     } catch (error) {
  //         console.error("Error in handleSummarizeQuestionResponse:", error);
  //     }
  // };
  const handleSubmitAnswerResForSender = ({ message = "", data = null }) => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      dispatch(getUserById(loggedUser));
      if (!data.sender || !data.sessionId || !data.receiver || !loggedUser)
        return;
      const { sessionId, isSummarizedGood, isEmotionView, sender } = data;
      if (sessionId !== loggedUser?.session_id) return;
      if (isEmotionView) {
        localStorage.setItem("firstStage", "true");
        navigate(
          `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.EMOTIONS}`,
        );
        dispatch(updateLastQuestionAsked(sender));
        //02-04-2025
        const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
        dispatch(getUserById(loggedUser));
        localStorage.setItem("lastStage", "first");
      } else {
        if (isSummarizedGood) {
          //  !UPDATE: CHANGE MADE HERE
          navigate(
            `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.USER_WAITING}`,
          );
        } else {
          navigate(
            `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.TELL_USER}`,
          );
        }
      }
    } catch (error) {
      console.error("Error in handleSummarizeQuestionResponse:", error);
    }
  };

  const handleSubmitAnswerResForReceiver = ({ message = "", data = null }) => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      dispatch(getUserById(loggedUser));
      if (!data.sender || !data.sessionId || !data.receiver || !loggedUser)
        return;
      const {
        sessionId,
        isSummarizedGood,
        isEmotionView,
        sender,
        isAnswer,
        answer,
      } = data;
      console.log("handleSubmitAnswerResForReceiver", data);
      if (sessionId !== loggedUser?.session_id) return;
      if (isEmotionView) {
        localStorage.setItem("firstStage", "true");
        navigate(
          `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.EMOTIONS}`,
        );
        dispatch(updateLastQuestionAsked(sender));
        //02-04-2025
        const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
        dispatch(getUserById(loggedUser));
        localStorage.setItem("lastStage", "first");
      } else {
        dispatch(updateLastSummaryRating(answer));
        setTimeout(() => {
          if (isSummarizedGood) {
            //  !UPDATE: CHANGE MADE HERE
            navigate(
              `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.CONTINUE_AFTER_FINISH}`,
            );
          } else if (isAnswer) {
            navigate(
              `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.SAY_SOMETHING}`,
            );
          } else {
            navigate(
              `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.TELL_USER}`,
            );
          }
          dispatch(updateLastSummaryRating(null));
        }, 4000);
      }
    } catch (error) {
      console.error("Error in handleSummarizeQuestionResponse:", error);
    }
  };

  const handleSubmitStatementResForSender = ({ message = "", data = null }) => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      dispatch(getUserById(loggedUser));
      if (!data.sender || !data.sessionId || !data.receiver || !loggedUser)
        return;
      const { sessionId, isSummarizedGood, isEmotionView, sender } = data;
      if (sessionId !== loggedUser?.session_id) return;
      if (isEmotionView) {
        localStorage.setItem("firstStage", "true");
        navigate(
          `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.EMOTIONS}`,
        );
        dispatch(updateLastQuestionAsked(sender));
        //02-04-2025
        const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
        dispatch(getUserById(loggedUser));
        localStorage.setItem("lastStage", "first");
      } else {
        if (isSummarizedGood) {
          //  !UPDATE: CHANGE MADE HERE
          navigate(
            `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.CONTINUE_AFTER_FINISH}`,
          );
        } else {
          navigate(
            `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.TELL_USER}`,
          );
        }
      }
    } catch (error) {
      console.error("Error in handleSummarizeQuestionResponse:", error);
    }
  };
  const handleSubmitStatementResForReceiver = ({
    message = "",
    data = null,
  }) => {
    console.log("summary response for receiver", data);
    try {
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      if (!data.sender || !data.sessionId || !data.receiver || !loggedUser)
        return;
      const {
        sessionId,
        receiver,
        sender,
        isSummarizedGood,
        isEmotionView,
        answer,
      } = data;
      if (
        sessionId !== loggedUser?.session_id ||
        loggedUser?.id !== receiver?.id
      )
        return;
      if (isEmotionView) {
        localStorage.setItem("firstStage", "true");
        // alert('I AM EMOTION VIEW')
        navigate(
          `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.EMOTIONS}`,
        );
        dispatch(updateLastQuestionAsked(sender));
        const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
        dispatch(getUserById(loggedUser));
        //02-04-2025
        localStorage.setItem("lastStage", "first");
      } else {
        dispatch(updateLastSummaryRating(answer));
        setTimeout(() => {
          if (isSummarizedGood) {
            //  !UPDATE: CHANGE MADE HERE
            navigate(
              `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.USER_WAITING}`,
            );
          } else {
            navigate(
              `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.SAY_SOMETHING}`,
            );
          }
          dispatch(updateLastSummaryRating(null));
        }, 4000);
      }
    } catch (error) {
      console.error("Error in handleSummarizeQuestionResponse:", error);
    }
  };

  //Emotion page continue discussion

  //SOCKET EMITTER CUSTOME FUNCATION
  const socketEventEmitter = (method, data) => {
    if (socket) {
      socket.emit(method, data);
    }
  };
  // Handle socket errors globally
  const handleSocketErr = ({ data, message }) => {
    const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
    if (
      !loggedUser ||
      loggedUser?.session_id !== data?.sessionId ||
      loggedUser?.id !== data?.sender?.id ||
      !data?.sessionId ||
      !data?.sender
    ) {
      return;
    }
    toast.error(message);
  };

  // Emitter to close session
  const _handleCloseSessionEmitter = () => {
    const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
    if (socket && loggedUser) {
      socket.emit(SOCKET_EVENT_TYPE.CLOSE_SESSION, loggedUser);
    }
  };
  // Handle session cancel for aksing modal response for sender
  const handleCancelSessionResponseForSender = ({ message, data }) => {
    const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
    const { sessionId, sender } = data;
    if (sessionId !== loggedUser?.session_id) return;
    if (loggedUser.id !== sender.id) return;
  };

  // Handle session cancel for aksing modal response for receiver
  const handlerCancelSessionResponseForReceiver = ({ message, data }) => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      if (!loggedUser || !data?.sessionId || !data?.receiver) return;
      const { sessionId, receiver, sender } = data;
      if (sessionId !== loggedUser.session_id) return;
      if (loggedUser.id !== sender.id) {
        navigate(
          `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.INFORMAL_STOP}`,
        );
      } else {
        navigate(
          `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.START_AFTER_STOP}`,
        );
      }
    } catch (error) {}
  };

  // Handle session cancel for aksing modal response for sender
  const handleConfirmCloseSessionSender = ({ message, data }) => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      const { session_id, sender } = data;
      if (session_id !== loggedUser?.session_id) return;
      if (loggedUser.id !== sender.id) return;
      navigate(
        `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.START_AFTER_STOP}`,
      );
    } catch (error) {
      console.log(error, "error");
    }
  };

  // Handle session cancel for aksing modal response for receiver
  const handleConfirmCloseSessionReceiver = ({ message, data }) => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      if (!loggedUser || !data?.session_id || !data?.receiver) return;
      const { session_id, receiver } = data;
      if (session_id !== loggedUser.session_id) return;
      if (loggedUser.id !== receiver.id) return;
      navigate(
        `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.START_AFTER_STOP}`,
      );
    } catch (error) {
      // console.error("Error in handlerCancelSessionResponseForReceiver:", error);
      // toast.error("An error occurred while handling the cancel session response.");
    }
  };

  const handleFinishAnswerSender = ({ message, data }) => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      if (!loggedUser || !data?.sessionId || !data?.receiver || !data?.sender)
        return;
      const { sessionId, sender } = data;
      if (sessionId !== loggedUser.session_id) return;
      if (loggedUser.id !== sender.id) return;
      navigate(
        `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.ANSWER_SUMMARIZE_LISTEN}`,
      );
    } catch (error) {
      // console.error("Error in handlerCancelSessionResponseForReceiver:", error);
      // toast.error("An error occurred while handling the cancel session response.");
    }
  };
  const handleFinishAnswerReceiver = ({ message, data }) => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      if (!loggedUser || !data?.sessionId || !data?.receiver || !data?.sender)
        return;
      const { sessionId, receiver } = data;
      if (sessionId !== loggedUser.session_id) return;
      if (loggedUser.id !== receiver.id) return;
      navigate(
        `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.ANSWER_SUMMARIZE_SAID}`,
      );
    } catch (error) {
      // console.error("Error in handlerCancelSessionResponseForReceiver:", error);
      // toast.error("An error occurred while handling the cancel session response.");
    }
  };
  //start discussion again after close the session
  const handleConfirmDiscussionStartAgainCloseTheSession = ({
    message,
    data,
  }) => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
      if (!loggedUser || !data?.sessionId || !data?.sender) return;
      const { sessionId, sender } = data;
      if (sessionId !== loggedUser.session_id) return;
      if (loggedUser.id !== sender.id) return;
      navigate(
        `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.USER_WAITING}`,
      );
    } catch (error) {
      // console.error("Error in handlerCancelSessionResponseForReceiver:", error);
      // toast.error("An error occurred while handling the cancel session response.");
    }
  };

  const stopSession = () => {
    navigate(USER_CURRENT_PATH.USER_WAITING);
    dispatch(updateIsCloseSession(true));
  };
  const backButton = () => {
    // navigate(`${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.HOME}`);
    // for (let i = localStorage.length - 1; i >= 0; i--) {
    //     const key = localStorage.key(i);
    //     if (!['setLang', 'langName', 'i18nextLng'].includes(key)) {
    //         localStorage.removeItem(key);
    //     }
    // }
    // dispatch(resetSessionState());
    dispatch(isNavOpen(true));
  };

  return {
    handleSocketErr,
    socketEventEmitter,
    _handleCloseSessionEmitter,
    handleCancelSessionResponseForSender,
    handlerCancelSessionResponseForReceiver,
    handleConfirmCloseSessionSender,
    handleConfirmCloseSessionReceiver,
    handleRoomJoined,
    handleJoinRoom,
    handleFinishedQuestionAsked,
    handlestatementMadeFinished,
    handleCreateSession,
    handleSummarizeQuestionFinish,
    handleFinishSummarizeQuestion,
    handleSummarizeQuestionResponse,
    handleSubmitSummariseResponse,
    handleStatementmentFinishBySender,
    handleFinishMakingStatement,
    handleFinishAskingQuestion,
    handleQuestionAsked,
    handleQuestionMake,
    handleFinishStatementResForSender,
    handleStatementmentFinishByReceiver,
    handleSubmitStatementResForSender,
    handleSubmitStatementResForReceiver,
    handleFinishAnswerSender,
    handleFinishAnswerReceiver,
    handleConfirmDiscussionStartAgainCloseTheSession,
    stopSession,

    handleSubmitAnswerResForSender,
    handleAnswerFinishBySender,
    handleAnswerFinishByReceiver,
    handleSubmitAnswerResForReceiver,

    backButton,
  };
};

export default useSocketHandlers;
